import { AbstractControl } from '@angular/forms'
import { AbstractValidator } from './abstract.validator'
import { ValidationTypes } from './validation.types'

export class RequiredPhoneValidator implements AbstractValidator {
  static type = ValidationTypes.validateWith

  static validateWith({ defaultCountry }: { defaultCountry: any }) {
    return (control: AbstractControl) => {
      const defaultCode = defaultCountry ? '+' + defaultCountry.e164 : '+'
      if (!control.value || control.value === '+' || control.value === defaultCode) {
        return { required: true }
      }
      return null
    }
  }
}
